import React from 'react'
import { Routes, Route } from 'react-router-dom';
import Layout from '../components/layout/layout.component';
import RequireAuth from '../components/auth/require-auth.component';
import RequireAdmin from '../components/auth/require-admin.component';
import StartRecordingPage from './start-recording/start-recording.page';
import FilesPage from './files/files.page';
import FilePage from './files/file.page';
import SpeakersPage from './speakers/speakers.page';
import TasksPage from './tasks/tasks.page';
import OverviewPage from './overview/overview.page';
import LandingPage from './landing/landing.page';
import LoginPage from './login/login.page';
import AiSettingsPage from './admin/ai-settings.page';
import TemplatesPage from './admin/templates.page';
import DepartmentsPage from './admin/departments.page';
import GlossaryPage from './admin/glossary.page';
import ProfilePage from './profile/profile.page';

const RoutesIndex = () => {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />

      <Route element={<RequireAuth />}>
        <Route element={<Layout />}>
          <Route path="/overview" element={<OverviewPage />} />
          <Route path="/start-recording" element={<StartRecordingPage />} />
          <Route path="/files" element={<FilesPage />} />
          <Route path="/files/:id" element={<FilePage />} />
          <Route path="/tasks" element={<TasksPage />} />
          <Route path="/speakers" element={<SpeakersPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/favorites" element={<FilesPage type='favorites' />} />
          <Route path="/trash" element={<FilesPage type='trash' />} />

          <Route element={<RequireAdmin />}>
            <Route path="/admin/ai-settings" element={<AiSettingsPage />} />
            <Route path="/admin/templates" element={<TemplatesPage />} />
            <Route path="/admin/departments" element={<DepartmentsPage />} />
            <Route path="/admin/glossary" element={<GlossaryPage />} />
          </Route>
        </Route>
      </Route>
    </Routes>
  )
}

export default RoutesIndex
